import { render } from "./LectureGroup.vue?vue&type=template&id=f48b212a&scoped=true"
import script from "./LectureGroup.vue?vue&type=script&lang=js"
export * from "./LectureGroup.vue?vue&type=script&lang=js"

import "./LectureGroup.vue?vue&type=style&index=0&id=f48b212a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f48b212a"

export default script